import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { safeGetItem } from './services/safe-storage';

const DASHBOARD_URL = '/dashboard';

function hasSession(): boolean {
  return !!safeGetItem('session', 'auth_token');
}

/**
 * Anonymous guard — protects login / signup routes from already-authenticated
 * users. If a session is active they are redirected to the post-auth dashboard
 * instead of being shown the credential entry form.
 */
export const anonymousGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (hasSession()) {
    return router.createUrlTree([DASHBOARD_URL]);
  }
  return true;
};

/**
 * Match-only variant — used to conditionally pick the root redirect target.
 * Returns true when the user has an active session.
 */
export const authedMatch: CanMatchFn = () => hasSession();

/**
 * Root-route redirect target — Angular forbids combining `canMatch` with
 * `redirectTo` (NG04014: redirects fire before guards run), so the
 * authed-vs-anonymous root branching is expressed as a function-based
 * `redirectTo` that picks the destination at navigation time.
 */
export const rootRedirectTo = (): string => (hasSession() ? '/dashboard' : '/home');
